import { config } from 'utils/config'

export interface ImageResizeOptions {
  aspect?: string
  quality?: number
  blur?: number
  sharpen?: number
  width?: number
  height?: number
  endpoint?: 'default' | 'cdn' | 'proxy'
  fallback?: string
  cropStrategy?: 'at_max' | 'at_least' | 'maintain_ratio'
}

export interface VideoThumbnailResizeOptions {
  width?: number
  height?: number
  cropStrategy?: 'at_max' | 'at_least' | 'maintain_ratio'
  startOffsetSeconds?: number
}

const OPTIONS_TO_IMAGEKIT_PARAMS: Record<string, string | null> = {
  aspect: 'ar',
  blur: 'bl',
  quality: 'q',
  sharpen: 'e-sharpen',
  width: 'w',
  height: 'h',
  endpoint: null,
  fallback: 'di',
  cropStrategy: 'c',
  startOffsetSeconds: 'so'
}

const buildImageKitParams = (options: Record<string, any>) => {
  return Object.entries(options)
    .map(([name, value]) => {
      const imagekitParam = OPTIONS_TO_IMAGEKIT_PARAMS[name as keyof ImageResizeOptions]
      if (imagekitParam !== null && value && value !== 0) {
        return `${imagekitParam}-${value}`
      } else {
        return null
      }
    })
    .filter(Boolean)
    .join(',')
}

export const imageEndpointForEnvironment = () => {
  switch (config.apiEnv) {
    case 'development':
      return 'tt-img-dev'

    case 'staging':
      return 'tt-img-staging'

    default:
      return null
  }
}

export const buildImagekitUrl = ({ options, path }: { options: Record<string, any>; path: string | null | undefined }) => {
  const urlParts: string[] = []
  const resizeParams = buildImageKitParams(options)

  if (!options.endpoint || options.endpoint === 'default') {
    const imageEndpoint = imageEndpointForEnvironment()
    if (imageEndpoint) {
      urlParts.push(imageEndpoint)
    }
  } else {
    urlParts.push(`tt-${options.endpoint}`)
  }

  if (resizeParams.length > 0) {
    urlParts.push(`tr:${resizeParams}`)
  }

  if (path) {
    urlParts.push(path)
  } else {
    urlParts.push('missing')
  }

  return `https://img.thingtesting.com/${urlParts.join('/')}`
}
